export const AGENTS_COLLECTION_NAME = 'agents';

export enum AgentDocumentCollections {
  emailAddresses = 'email-addresses',
  associations = 'associations',
  approveDenyReason = 'approve-deny-reason',
  gridsConfigurations = 'grids-configurations',
  media = 'media',
  fileDirectories = 'fileDirectories',
  pushNotifications = 'push-notifications',
  notificationChannels = 'notification-channels',
}

export enum AgentKeys {
  uid = 'uid',
  p_agent_id = 'p_agent_id',
  p_external_agent_id = 'p_external_agent_id',
  p_email = 'p_email',
  p_agent_name = 'p_agent_name',
  p_agent_first_name = 'p_agent_first_name',
  p_agent_middle_name = 'p_agent_middle_name',
  p_agent_last_name = 'p_agent_last_name',
  p_passport_first_name = 'p_passport_first_name',
  p_passport_last_name = 'p_passport_last_name',
  p_agency_id = 'p_agency_id',
  p_mga_id = 'p_mga_id',
  title = 'title',
  p_prefix = 'p_prefix',
  p_suffix = 'p_suffix',
  npn = 'npn',
  p_strategic_agent = 'p_strategic_agent',
  alliance_group_employee = 'alliance_group_employee',
  upline = 'upline',
  emailVerified = 'emailVerified',
  registrationDate = 'registrationDate',
  approvalDate = 'approvalDate',
  approvedBy = 'approvedBy',
  role = 'role',
  roles = 'roles',
  agent_type = 'agent_type',
  billing_shipping_same = 'billing_shipping_same',
  agencyName = 'agencyName',
  personal_goals = 'personal_goals',
  conference_goals = 'conference_goals',
  manager_goals = 'manager_goals',
  p_registered_user = 'p_registered_user',
  registration_source = 'registration_source',
  first_login_date = 'first_login_date',
  last_login_date = 'last_login_date',
  login_count = 'login_count',
  pwa_login_count = 'pwa_login_count',
  logged_in = 'logged_in',
  is_manager = 'is_manager',
  is_rmd = 'is_rmd',
  is_credited = 'is_credited',
  manager_id = 'manager_id',
  approve_deny_reason = 'approve_deny_reason',
  approve_deny_reasons = 'approve_deny_reasons',
  agency_approve_deny_reason = 'agency_approve_deny_reason',
  showSplashScreen = 'showSplashScreen',
  favorites = 'favorites',
  is_acb_user = 'is_acb_user',
  is_awb_user = 'is_awb_user',
  is_arm_user = 'is_arm_user',
  awb_site_id = 'awb_site_id',
  certifications = 'certifications',
  agent_status = 'agent_status',
  agent_review_level = 'agent_review_level',
  registrant_review_level_update_date = 'registrant_review_level_update_date',
  registration_status = 'registration_status',
  prospect_status = 'prospect_status',
  prospect_priority = 'prospect_priority',
  prospect_disposition = 'prospect_disposition',
  prospect_referred_to = 'prospect_referred_to',
  prospect_referred_to_date = 'prospect_referred_to_date',
  prospect_wrap_up_notes = 'prospect_wrap_up_notes',
  prospect_status_update_date = 'prospect_status_update_date',
  addresses = 'addresses',
  socials = 'socials',
  websites = 'websites',
  email_addresses = 'email_addresses',
  phone_numbers = 'phone_numbers',
  isActiveCampaigns = 'isActiveCampaigns',
  campaigns = 'campaigns',
  race = 'race',
  ethnicity = 'ethnicity',
  gender = 'gender',
  primary_language = 'primary_language',
  secondary_language = 'secondary_language',
  hobbies = 'hobbies',
  favorite_destination = 'favorite_destination',
  shoe_size = 'shoe_size',
  agent_carriers = 'agent_carriers',
  state_licenses = 'state_licenses',
  christmas_card = 'christmas_card',
  conference_poster = 'conference_poster',
  dob = 'dob',
  headshot = 'head_shot',
  fcmTokens = 'fcm_tokens',
  tShirtSizes = 'tShirtSizes',
  dietaryConsideration = 'dietaryConsideration',
  flightPreference = 'flightPreference',
  notificationChannels = 'notificationChannels',
  downloadedWasabiPaths = 'downloadedWasabiPaths',
  privacyPolicyVersion = 'privacyPolicyVersion',
  privacyPolicyDate = 'privacyPolicyDate',
  termsOfServicesVersion = 'termsOfServicesVersion',
  termsOfServicesDate = 'termsOfServicesDate',
}
